import React from 'react';
import NavBar from '../NavBar';
import Atlantico from './Atlantico';
import Boat3D from './openSource/Boat3D';
import OpenSource from './openSource/OpenSource';
import Footer from "../Footer";


const atlanticoPrototype = {
  title: 'Atlântico',
  description: 'Atlântico is a sustainable prototype fully powered by solar energy, using high-efficiency solar panels to supply its electric motor with zero CO2 emissions. The boat is built primarily from eco-friendly and sustainable materials, reflecting the team\'s commitment to innovation and environmental responsibility.',
  topics: [
    {
      title: 'MASS',
      value: '300 kg',
    },
    {
      title: 'LENGTH',
      value: '6 m',
    },
    {
      title: 'BATTERY POWER',
      value: '1.5 kWh',
    },
  ],
};

function AtlanticoPage() {
    return (
        <div>
            <NavBar />
            <Atlantico />
            <Boat3D prototype={atlanticoPrototype} />
            <OpenSource />
            <Footer />
        </div>
    );
}

export default AtlanticoPage;
